export const MINUTES_PER_HOUR = 60;
export const HIGH_HOURS_THRESHOLD = 3;
export const DEVIATION_THRESHOLD_MINUTES = 30;
export const UNUSUAL_HOURS_START = 20; // 8 PM
export const UNUSUAL_HOURS_END = 6; // 6 AM
